import { render } from "./TheReport.vue?vue&type=template&id=647c1b73"
import script from "./TheReport.vue?vue&type=script&lang=js"
export * from "./TheReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__